import React from 'react';
import PropTypes from 'prop-types';

const ResultsHeader = ({searchTerm, itemsArray, language}) => {

	const translateText = (language, enText, frText) => {
		if (language === "fr-FR") return frText;
		return enText;
	}

	if (!itemsArray.length && searchTerm) {
		return <h2 className='single-collection-page__results-header'>{translateText(language, "No results for", "Aucun résultat ne correspond à votre recherche pour")} &ldquo;{searchTerm}&rdquo;</h2>;
	}

	if (itemsArray.length && searchTerm) {
		return <h2 className='single-collection-page__results-header'>{translateText(language, "Results for", "Résultats de la recherche pour")} &ldquo;{searchTerm}&rdquo;</h2>
	}
}

export default ResultsHeader;

ResultsHeader.propTypes = {
	searchTerm: PropTypes.string,
	itemsArray: PropTypes.array,
	language: PropTypes.string,
}